// extracted by mini-css-extract-plugin
export default {"center":"select-role_center__5EJ0N","select-role":"select-role_select-role__coQjA","lozenge":"select-role_lozenge__L0-Gs","input-button":"select-role_input-button__cYWkc"};